export const tableHeaders = {
  companyName: { title: 'companyName', sortField: 1 },
  projectName: { title: 'projectName', sortField: 2 },
  owner: { title: 'owner', sortField: 3 },
  lastModified: { title: 'lastModified', sortField: 4 },
  dateCreated: { title: 'dateCreated', sortField: 5 },
};

export const pageSize = 10;
